import { useDispatch, useSelector } from '@ecommerce/nest-ssr/common';
import { useCallback } from 'react';
import { ModalsActions, ModalsState } from '../reducers/modals';

export const useModal = (modalId: string): { isOpen: boolean; open: () => void; close: () => void; } => {
    const dispatch = useDispatch();

    const isOpen: boolean = useSelector(
        (state: { modals: ModalsState; }) => state.modals?.openedModal === modalId
    );

    const open = useCallback(() => {
        dispatch({ type: ModalsActions.OpenModal, payload: { openedModal: modalId } });
    }, [modalId]);

    const close = useCallback(() => {
        dispatch({ type: ModalsActions.CloseModal });
    }, []);

    return { isOpen, open, close };
};
